
import type { QueryParameters } from "../types/QueryParameters";


export function formatDate(date:string|number|undefined,options?: Intl.DateTimeFormatOptions){
    return date? new Intl.DateTimeFormat("fr-BE",options).format(new Date(date)):'';
}
export const toBase64 = (file:Blob):Promise<string | ArrayBuffer | null> => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {resolve(reader.result)};
        reader.onerror = reject;
});
export function uniqid(prefix = "", random = false) {
    const sec = Date.now() * 1000 + Math.random() * 1000;
    const id = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
    return `${prefix}${id}${random ? `.${Math.trunc(Math.random() * 100000000).toString()}`:""}`;
};


/**
 * Format bytes as human-readable text.
 * 
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use 
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 * 
 * @return Formatted string.
 */
export function humanFileSize(bytes:number, si=false, dp=1) {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes.toFixed(2) + ' B';
  }

  const units = si 
    ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
    : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
  let u = -1;
  const r = 10**dp;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


  return bytes.toFixed(dp) + ' ' + units[u];
}

export function buildParams(data:QueryParameters):string {
    const s:string[] = [];
    const add = function (k:string | number | boolean, v:string | number |null| undefined | (() => string)) {
        v = typeof v === 'function' ? v() : v;
        v = v ?? '';
        s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const buildParams = function (prefix:string, obj:any) {
        let i, len, key;

        if (prefix) {
            if (Array.isArray(obj)) {
                for (i = 0, len = obj.length; i < len; i++) {
                    buildParams(
                        prefix + '[' + (typeof obj[i] === 'object' && obj[i] ? i.toString() : '') + ']',
                        obj[i]
                    );
                }
            } else if (Object.prototype.toString.call(obj) === '[object Object]') {
                for (key in obj) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    buildParams(prefix + '[' + key + ']', obj[key]);
                }
            } else {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                add(prefix, obj);
            }
        } else if (Array.isArray(obj)) {
            // array of [{name:x,value:x}]
            for (i = 0, len = obj.length; i < len; i++) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
                add(obj[i].name, obj[i].value);
            }
        } else {
            for (key in obj) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                buildParams(key, obj[key]);
            }
        }
        return s;
    };

    return buildParams('', data).join('&');

}

export const getByPath = (from:unknown, ...selectors:string[]) =>
  [...selectors].map((s) =>
    s
      .replace(/\[([^[\]]*)\]/g, ".$1.")
      .split(".")
      .filter((t) => t !== "")
      .reduce((prev, cur) => prev?.[cur as keyof typeof prev], from)
  ).filter((t) => t !== undefined && t!==null);

 


